import logo from "../logo-header-shortened.png";
import "./NavBar.css";
import { Icon } from "@iconify/react/dist/iconify.js";

function NavBar() {
  return (
    <div id="header">
      <div id="logo">
        <img
          src={logo}
          height="60"
          style={{ borderRadius: "8px" }}
          alt="Charleston Empanadas logo"
        />
      </div>
      <nav id="navbar" style={{ display: "flex", gap: "16px" }}>
        <a
          href="https://www.instagram.com/chsempanadas/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", margin: 0, padding: 0 }}
        >
          <Icon
            icon="mdi:instagram"
            style={{
              fontSize: "32px",
              color: "#ea2146ff",
              verticalAlign: "middle",
            }}
          />
        </a>
        {/* <a
          href="https://www.facebook.com/profile.php?id=61579323742636"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", margin: 0, padding: 0 }}
        >
          <Icon
            icon="mdi:facebook"
            style={{
              fontSize: "32px",
              color: "#1877F3",
              verticalAlign: "middle",
            }}
          />
        </a> */}
      </nav>
    </div>
  );
}

export default NavBar;
